import React, { Component } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from './styles'
import { confirmCodeAction } from '../../reducers/sign-up/action.js'
import { connect } from 'react-redux'
import propTypes from './prop'
import translator from '../../translate'
import { snackbarDispose } from '../../reducers/snackbar/action'
import { withSnackbar } from 'notistack'
import { get as getCookie } from 'es-cookie'
import { styled } from '@material-ui/core/styles'
import Page from '../../components/Page'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

import {
  Typography,
  Grid,
  Box,
  Container,
  Card,
  Divider,
  makeStyles
} from '@material-ui/core'

import { CoreFormLayout, CoreTextField } from 'src/components/core'
import { LoadingButton } from '@material-ui/lab'

// ----------------------------------------------------------------------

const logos = [
  'logo_amazon',
  'logo_cisco',
  'logo_combinator',
  'logo_ibm',
  'logo_intel',
  'logo_microsoft',
  'logo_netflix',
  'logo_slack',
  'logo_spotify',
  'logo_twitter',
  'logo_vimeo',
  'logo_airbnb'
]

const useStyles = makeStyles((theme) => ({
  marqueeContainer: {
    width: '100%',
    overflow: 'hidden',
    position: 'relative',
    padding: '20px 0',
    marginBottom: '40px',
    maxWidth: '540px',
    maskImage: 'linear-gradient(to right, transparent, black 10%, black 90%, transparent)',
    WebkitMaskImage: 'linear-gradient(to right, transparent, black 10%, black 90%, transparent)',
  },
  marqueeContent: {
    display: 'flex',
    width: 'max-content',
  },
  marqueeGroup: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    // Reference the global keyframes defined in App.css or global styles
    animation: 'marqueeScroll 40s linear infinite',
    gap: theme.spacing(10),
  },
}))

const LogosMarquee = () => {
  const classes = useStyles()
  return (
    <div className={classes.marqueeContainer}>
      <div className={classes.marqueeContent}>
        <div className={classes.marqueeGroup}>
          {logos.map((logo, index) => (
            <Box
              component="img"
              key={index}
              src={`/assets/login-logos/${logo}.svg`}
              alt={`logo-${logo}`}
              sx={{ height: 32, width: 'auto', objectFit: 'contain' }}
            />
          ))}
          {logos.map((logo, index) => (
            <Box
              component="img"
              key={`dup-${index}`}
              src={`/assets/login-logos/${logo}.svg`}
              alt={`logo-${logo}`}
              sx={{ height: 32, width: 'auto', objectFit: 'contain' }}
            />
          ))}
        </div>
      </div>
      <style>
        {`
                    @keyframes marqueeScroll {
                        0% { transform: translateX(0); }
                        100% { transform: translateX(-50%); }
                    }
                    .${classes.marqueeGroup}:hover {
                        animation-play-state: paused;
                    }
                `}
      </style>
    </div>
  )
}

const RootStyle = styled(Page)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(3),
  backgroundColor: '#fff',
  position: 'relative',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    padding: 0,
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    bottom: '-20%',
    right: '-15%',
    width: '839px',
    height: '839px',
    borderRadius: '839px',
    background: 'linear-gradient(180deg, rgba(254, 225, 80, 0.50) 0%, rgba(225, 251, 255, 0.50) 100%)',
    filter: 'blur(200px)',
    zIndex: 0,
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '-10%',
    right: '-10%',
    width: '467.584px',
    height: '467.584px',
    borderRadius: '467.584px',
    background: '#DFD0FF',
    filter: 'blur(229.20791625976562px)',
    zIndex: 0,
  },
}))

const LeftPanel = styled(Box)(({ theme }) => ({
  flex: 1,
  paddingTop: '40px',
  paddingBottom: '40px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    alignItems: 'center',
    padding: '32px 24px',
  },
}))

const FormCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  padding: '72px 48px',
  flexDirection: 'column',
  alignItems: 'flex-start',
  borderRadius: '24px',
  background: '#FFF',
  boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.12), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
  width: '520px',
  maxWidth: '100%',
  borderTop: `6px solid ${theme.palette.primary.main}`,
  position: 'relative',
  zIndex: 2,
  [theme.breakpoints.down('md')]: {
    padding: '48px 24px',
  },
}))

class CheckVerificationCode extends Component {
  state = {
    code1: null,
    code2: null,
    code3: null,
    code4: null,
  }

  /**
   *
   */
  onHandleSignUp = event => {
    event.preventDefault()

    const code =
      event.target.code1.value +
      event.target.code2.value +
      event.target.code3.value +
      event.target.code4.value
    const data = {
      email: getCookie('email'),
      code,
      isRedirect: false,
    }

    this.props.dispatch(confirmCodeAction(data))
  }

  /**
   *
   */
  code1Control = e => {
    let val = e.target.value
    if (val.length == 4) {
      let val1 = val.slice(0, 1)
      let val2 = val.slice(1, 2)
      let val3 = val.slice(2, 3)
      let val4 = val.slice(3, 4)
      this.setState({ code1: val1, code2: val2, code3: val3, code4: val4 }, () => {
        const code = val1 + val2 + val3 + val4
        const data = {
          email: getCookie('email'),
          code,
          isRedirect: false,
        }
        this.props.dispatch(confirmCodeAction(data))
      })
    } else {
      if (val > 9) {
        val = val.slice(-1)
      }
      if (val < 0) {
        val = 0
      }
      this.code2.focus()

      this.setState({ code1: val })
    }
  }

  /**
   *
   * @param {*} e
   */
  code2Control = e => {
    let val = e.target.value

    if (val > 9) {
      val = val.slice(-1)
    }
    if (val < 0) {
      val = 0
    }
    this.code3.focus()

    this.setState({ code2: val })
  }

  /**
   *
   * @param {*} e
   */
  code3Control = e => {
    let val = e.target.value

    if (val > 9) {
      val = val.slice(-1)
    }
    if (val < 0) {
      val = 0
    }
    this.code4.focus()

    this.setState({ code3: val })
  }

  /**
   *
   */
  code4Control = e => {
    let val = e.target.value

    if (val > 9) {
      val = val.slice(-1)
    }

    if (val < 0) {
      val = 0
    }

    this.setState({ code4: val })
  }

  /**
   *
   */
  render() {
    const { classes } = this.props
    const email = getCookie('email') || 'example@email.com';
    const { code1, code2, code3, code4 } = this.state
    const allCodesFilled = code1 != null && code1 !== '' && code2 != null && code2 !== '' && code3 != null && code3 !== '' && code4 != null && code4 !== ''

    return (
      <RootStyle title="Verify Code | Mini-Course Generator">
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>

          {/* Blue Blur Blob */}
          <Box
            sx={{
              position: 'absolute',
              top: '3%',
              right: '20%',
              width: '300px',
              height: '300px',
              background: '#0094FF',
              filter: 'blur(150px)',
              borderRadius: '9999px',
              zIndex: -1,
              opacity: 0.6,
            }}
          />

          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center', justifyContent: 'center' }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', maxWidth: '520px', zIndex: 2 }}>
              <FormCard>
                {/* Form Header */}
                <Box sx={{ width: '100%', textAlign: 'left', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', mb: { xs: '24px', md: '48px' } }}>
                    <Box component="img" src="/assets/mcg-icon.svg" sx={{ width: 40, height: 40 }} />
                    <Box component="img" src="/assets/mcg-text.svg" sx={{ width: '162.667px', height: 40 }} />
                  </Box>
                  <Typography sx={{
                    color: '#002E47',
                    fontFamily: 'Inter',
                    fontSize: { xs: '24px', md: '32px' },
                    fontStyle: 'normal',
                    fontWeight: 700,
                    lineHeight: '150%',
                    mb: 1
                  }}>
                    Verification Code
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'left' }}>
                    We've sent a 4-digit code to [{email}]
                  </Typography>
                  <Typography sx={{ color: '#002E47', fontFamily: 'Inter', fontSize: '16px', fontStyle: 'normal', fontWeight: 400, lineHeight: '150%', textAlign: 'left', marginTop: { xs: '24px', md: '48px' }, marginBottom: '4px' }}>
                    Please check your inbox or spam folder and enter the code below to continue.
                  </Typography>
                </Box>

                <form className={classes.form} onSubmit={this.onHandleSignUp}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      flexWrap: 'nowrap',
                      width: '100%',
                      gap: '10px',
                    }}
                  >
                    <CoreTextField
                      name="code1"
                      value={this.state.code1}
                      required
                      fullWidth
                      id="code1"
                      autoFocus
                      inputRef={input => { this.code1 = input }}
                      onChange={this.code1Control}
                      inputProps={{ style: { textAlign: 'center', fontSize: '24px' } }}
                    />
                    <CoreTextField
                      value={this.state.code2}
                      required
                      fullWidth
                      id="code2"
                      name="code2"
                      inputRef={input => { this.code2 = input }}
                      onChange={this.code2Control}
                      inputProps={{ style: { textAlign: 'center', fontSize: '24px' } }}
                    />
                    <CoreTextField
                      value={this.state.code3}
                      required
                      fullWidth
                      id="code3"
                      name="code3"
                      inputRef={input => { this.code3 = input }}
                      onChange={this.code3Control}
                      inputProps={{ style: { textAlign: 'center', fontSize: '24px' } }}
                    />
                    <CoreTextField
                      value={this.state.code4}
                      required
                      fullWidth
                      id="code4"
                      name="code4"
                      inputRef={input => { this.code4 = input }}
                      onChange={this.code4Control}
                      inputProps={{ style: { textAlign: 'center', fontSize: '24px' } }}
                    />
                  </Box>

                  <LoadingButton
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    sx={{
                      height: '48px',
                      padding: '15px 22px',
                      marginTop: { xs: '24px', md: '48px' },
                      backgroundColor: allCodesFilled ? 'primary.main' : '#919eab',
                      '&:hover': {
                        backgroundColor: allCodesFilled ? 'primary.dark' : '#637381',
                      },
                    }}
                  >
                    Verify & Access
                  </LoadingButton>

                  <Box sx={{ marginTop: '16px', textAlign: 'center' }}>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                      Didn't receive the code?{' '}
                      <Typography
                        component="span"
                        variant="subtitle2"
                        sx={{
                          color: '#015ffb',
                          fontWeight: 'bold',
                          cursor: 'pointer'
                        }}
                        onClick={() => window.location.href = '/login'} // Or resend logic
                      >
                        Resend Code
                      </Typography>
                    </Typography>
                  </Box>
                </form>
              </FormCard>
            </Box>
          </Box>
        </Container>
      </RootStyle>
    )
  }

  /**
   *
   */
  componentDidUpdate() {
    const { snackbar, enqueueSnackbar, dispatch } = this.props
    if (snackbar.messages) {
      snackbar.messages.forEach(message => {
        message.messageIds.forEach(messageId => {
          enqueueSnackbar(translator._(messageId), {
            preventDuplicate: true,
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'center',
            },
          })
        })
        dispatch(snackbarDispose(message.id))
      })
    }
  }
}

CheckVerificationCode.propTypes = propTypes

const mapStateToProps = response => ({
  authentication: response.authentication,
  snackbar: response.snackbar,
})

export default connect(mapStateToProps)(
  withStyles(styles)(withSnackbar(CheckVerificationCode)),
)
